export default __webpack_public_path__ + "images/V0.6fa55f2.png";